import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import globalMessages from 'src/services/globalMessages';

export interface IHeadMetaDataProps {
    companyName: string;
}

const HeadMetaData: React.FunctionComponent<IHeadMetaDataProps> = ({companyName}) => {
    const intl = useIntl();
    const bookingText = intl.formatMessage(globalMessages.booking);
    const companyNameWithBookingText = `${companyName} - ${bookingText}`;
    const description = intl.formatMessage(globalMessages.metaDescription, { companyName });

    return (
        <Helmet>
            {<title>{companyNameWithBookingText}</title>}
            {<meta name="title" content={companyNameWithBookingText} />}
            {<meta name="description" content={description} />}
            <script type="application/ld+json">
                {JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'WebSite',
                    'name': companyNameWithBookingText,
                    'url': window.location.origin,
                })}
            </script>
        </Helmet>
    );
};

export default HeadMetaData;